var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiCard',{staticClass:"promotions-mechanism",attrs:{"title":"Działanie mechanizmów promocyjnych w zależności od rodzaju Urządzenia na stanowisku sprzedaży"}},[_c('a',{attrs:{"href":`/regulations/${_vm.promotionsMechanismFile.path}`,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.promotionsMechanismFile.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }